//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.NCGroupBuilder.js";
import "../CAM/CAM.InheritableIntBuilder.js";
import "../CAM/CAM.HoldingSystemBuilderList.js";
import "../CAM/CAM.InheritableTextBuilder.js";
import "../no/ObjectList.js";
let d=[[[1,"AdjustIdBuilder",0,"CAM.InheritableIntBuilder",0],[0,"AdjustRegisterType",1,1],[0,"ChannelName",1,0],[1,"CutcomIdBuilder",0,"CAM.InheritableIntBuilder",0],[0,"CutcomRegisterType",1,1],[1,"HoldingSystemsList",0,"CAM.HoldingSystemBuilderList",0],[0,"NumberOfTools",1,0],[1,"PocketIdBuilder",0,"CAM.InheritableIntBuilder",0],[1,"PocketIdStringBuilder",0,"CAM.InheritableTextBuilder",0]],[[["position","name"],"CreateHoldingSystemBuilder",{R_:{holdingSystemBuilder:"CAM.HoldingSystemBuilder"}},2,0]],[]];
SPLM.CAM.MachinePocketGroupBuilder = class extends SPLM.CAM.NCGroupBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.MachinePocketGroupBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.MachinePocketGroupBuilder.RegisterType = Object.freeze({
    "SameAsPocketId" : "SameAsPocketId", "Specify" : "Specify"});

export default SPLM;